import { TEACHER_TYPE, TEACHER_TYPE_TRAINING, TRAINING_STATUS } from 'constants/index'

export function checkIsTraining(user) {
  const teacherSource = +user?.teacher_source
  const teacherTypeTraining = +user?.teacher_type
  const trainingStatus = +user?.training?.training_status

  if (
    trainingStatus === TRAINING_STATUS.TRAINING_STATUS_DONE ||
    (trainingStatus === TRAINING_STATUS.TRAINING_STATUS_TEACHING &&
      teacherTypeTraining === TEACHER_TYPE_TRAINING.OFFICIAL) ||
    (trainingStatus === TRAINING_STATUS.TRAINING_STATUS_TEST &&
      teacherTypeTraining === TEACHER_TYPE_TRAINING.TESTER) ||
    teacherSource !== TEACHER_TYPE.KYNA
  )
    return true

  return false
}
